/*eslint-disable*/
import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";

// core components
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";

import LoadingData from '../lottieLoading.js';

// views for this page
import OrderStageOne from "../../../trade-customer-portal/views/OrderProcessPage/Sections/StageOne/OrderStageOnePage.js"
import FooterSection from "trade-customer-portal/views/footer.js"
import HeaderSection from "trade-customer-portal/views/header.js";
import { useDispatch, useSelector } from "react-redux";

// styling 
import orderStyle from "assets/jss/CustomerTradePortal/views/orderProcessPageStyle.js";
const useStyles = makeStyles(orderStyle);

export default function OrderProcessPage() {

    const loading = useSelector(state => state.userReducer.loadingPage);


    React.useEffect(() => {
        window.scrollTo(0, 0);


        TestingAuth();


    });

    function TestingAuth() {
        //console.log("hello")
    }

    const classes = useStyles();


    if (loading === false) {
        return (
            <div >
                <HeaderSection />

                {/* <Parallax
                    image={require("assets/img/cadebyDepot.jpg")}
                    filter="dark"
                    xsmall
                > */}
                <div className={classNames(classes.main, classes.mainRaised, classes.mainSection, classes.sidePageMainSection)}>
                    <div className={classes.container}>
                        <GridContainer justify="center">
                            <GridItem
                                md={7}
                                sm={8}
                                className={classNames(
                                    classes.mlAuto,
                                    classes.mrAuto,
                                    classes.textCenter
                                )}
                            >
                                <h1 className={classes.title} style={{ color: "black" }}>Process New Order</h1>
                            </GridItem>
                            <GridItem md={7} sm={8} className={classNames(classes.mlAuto, classes.mrAuto)}>
                                <div className={classes.sidePageBorderLine} />
                            </GridItem>
                        </GridContainer>
                        <OrderStageOne />
                        <br />
                    </div>
                </div>
                {/* </Parallax> */}

                {/* <div className={classNames(classes.main, classes.mainRaised)} >
                    <div className={classes.container} > */}
                        {/*<h5 className={classes.description} style={{ padding: "40px 0 0 0", textAlign: "justify" }}>*/}
                        {/*    Our fencing products are manufactured at our Cadeby depot.*/}
                        {/*    FP McCann’s precast concrete fencing products are durable, easy to install and provide an attractive*/}
                        {/*    finish in combination with timber fencing panels. Our Fenn-Lite™ fencing posts and gravel boards are up to 45%*/}
                        {/*    lighter and offer the same strength and durability as standard weight products.*/}
                        {/*    <b> FP McCann will deliver to locations throughout the UK/Ireland and our sales and technical teams are on hand to discuss your requirements. </b>*/}
                        {/*</h5>*/}
                        {/* <OrderStageOne />
                        <br />
                    </div>
                </div> */}



                <FooterSection />
            </div>
        );



    }
    else {
        return (<LoadingData text={"Please Wait...."} />)
    }
}